import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { showErrorMessage } from '@/shared/components/toast-system';
import * as constants from '../constants';

const InstagramCallback = () => {
  const navigate = useNavigate();
  const channelsRoute = constants.ENABLE_NEW_UI ? '/channels' : constants.ROUTE_CHANNELS;

  useEffect(() => {
    const alreadyProcessed = sessionStorage.getItem('instagram_callback_processed') === 'true';

    if (alreadyProcessed) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('instagram_code');
    const errorParam = urlParams.get('instagram_error');

    if (errorParam) {
      showErrorMessage('Instagram connection failed: ' + decodeURIComponent(errorParam));
      navigate(channelsRoute);
      return;
    }

    if (code) {
      sessionStorage.setItem('instagram_callback_processed', 'true');

      // Store the code in sessionStorage for InstagramConnect to pick up
      sessionStorage.setItem('instagram_auth_code', code);
      sessionStorage.setItem('instagram_auth_pending', 'true');

      setTimeout(() => {
        sessionStorage.removeItem('instagram_callback_processed');
      }, 1000);

      // Navigate to channels where PublishModalWithSocial will restore the flow
      navigate(channelsRoute);
    } else if (window.location.search) {
      showErrorMessage('Invalid Instagram callback parameters');
      navigate(channelsRoute);
    } else {
      navigate(channelsRoute);
    }
  }, [navigate, channelsRoute]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div className="spinner" style={{ fontSize: '48px' }}>
        <i className="bx bx-loader-alt bx-spin"></i>
      </div>
      <p style={{ marginTop: '20px' }}>Processing Instagram connection...</p>
    </div>
  );
};

export default InstagramCallback;
